var _toConsumableArray = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _classCallCheck = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

// References:
// https://github.com/FactomProject/FactomDocs/blob/FD-849_PublishNewIdentitySpec/ApplicationIdentity.md
// https://github.com/FactomProject/factom/blob/FD-732_release_2.2.15/identity.go#L72
var Joi = require('joi').extend(require('joi-factom'));

var sign = require('tweetnacl/nacl-fast').sign;

var _require = require('./key-helpers'),
    isValidPublicIdentityKey = _require.isValidPublicIdentityKey,
    extractCryptoMaterial = _require.extractCryptoMaterial;

var INITIAL_KEYS_SCHEMA = Joi.object().keys({
  version: Joi.number().valid(1).required(),
  keys: Joi.array().min(1).unique().items(Joi.factom().identityKey('public')).required()
});
var CACHE_SCHEMA = Joi.object().keys({
  keys: Joi.object().required(),
  names: Joi.object().required()
});

var IdentityInformationRetriever =
/*#__PURE__*/
function () {
  "use strict";

  function IdentityInformationRetriever(cli) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, IdentityInformationRetriever);

    this.cli = cli;
    this.save = opts.save ||
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    if (opts.initialCacheData) {
      Joi.assert(opts.initialCacheData, CACHE_SCHEMA);
      this.cache = opts.initialCacheData;
    } else {
      this.cache = {
        keys: {},
        names: {}
      };
    }
  }

  _createClass(IdentityInformationRetriever, [{
    key: "saveCache",
    value: function saveCache() {
      return this.save(this.cache);
    }
  }, {
    key: "getActiveKeysAtHeight",
    value: function () {
      var _getActiveKeysAtHeight = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(identityChainId) {
        var blockHeight,
            cachedData,
            saveCache,
            entries,
            firstEntry,
            activeKeys,
            latestDataCached,
            _entries,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                blockHeight = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : Infinity;
                cachedData = getCachedData.call(this, identityChainId);
                saveCache = false;

                if (!(cachedData.length === 0)) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 6;
                return getEntries(this.cli, identityChainId);

              case 6:
                entries = _context2.sent;

                if (!(entries.length === 0)) {
                  _context2.next = 9;
                  break;
                }

                throw new Error("Invalid identity chain [".concat(identityChainId, "]"));

              case 9:
                firstEntry = entries.shift();
                activeKeys = getInitialKeys(firstEntry);
                cacheIdentityName.call(this, identityChainId, firstEntry);
                cachedData.push({
                  height: firstEntry.blockContext.directoryBlockHeight,
                  activeKeys: _toConsumableArray(activeKeys),
                  allKeys: _toConsumableArray(activeKeys)
                });
                saveCache = true;
                applyKeyRotations(identityChainId, activeKeys, activeKeys, entries, cachedData);
                _context2.next = 23;
                break;

              case 17:
                latestDataCached = cachedData[cachedData.length - 1]; // If the data is requested for an height lower than what was alreay parsed
                // it means we don't need to fetch anything more and just read the result from the cached data
                // Otherwise fetch the entries down to the latest height that was processed

                if (!(blockHeight > latestDataCached.height)) {
                  _context2.next = 23;
                  break;
                }

                _context2.next = 21;
                return getEntries(this.cli, identityChainId, latestDataCached.height);

              case 21:
                _entries = _context2.sent;

                if (_entries.length > 0) {
                  applyKeyRotations(identityChainId, latestDataCached.activeKeys, latestDataCached.allKeys, _entries, cachedData);
                  saveCache = true;
                }

              case 23:
                if (!saveCache) {
                  _context2.next = 26;
                  break;
                }

                _context2.next = 26;
                return this.saveCache();

              case 26:
                return _context2.abrupt("return", findActiveKeysAtHeight(cachedData, blockHeight));

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getActiveKeysAtHeight(_x) {
        return _getActiveKeysAtHeight.apply(this, arguments);
      }

      return getActiveKeysAtHeight;
    }()
  }, {
    key: "getIdentityName",
    value: function () {
      var _getIdentityName = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(identityChainId) {
        var firstEntry;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.cache.names[identityChainId]) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", this.cache.names[identityChainId].map(function (n) {
                  return Buffer.from(n, 'hex');
                }));

              case 2:
                _context3.next = 4;
                return this.cli.getFirstEntry(identityChainId);

              case 4:
                firstEntry = _context3.sent;
                // getInitialKeys() is used to validate that this is a valid identity chain first entry
                getInitialKeys(firstEntry);
                cacheIdentityName.call(this, identityChainId, firstEntry);
                _context3.next = 9;
                return this.saveCache();

              case 9:
                return _context3.abrupt("return", this.cache.names[identityChainId].map(function (n) {
                  return Buffer.from(n, 'hex');
                }));

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getIdentityName(_x2) {
        return _getIdentityName.apply(this, arguments);
      }

      return getIdentityName;
    }()
  }]);

  return IdentityInformationRetriever;
}();

function findActiveKeysAtHeight(cachedData, blockHeight) {
  if (cachedData[0].height > blockHeight) {
    throw new Error("Identity chain didn't exist at height ".concat(blockHeight));
  }

  for (var i = cachedData.length - 1; i >= 0; --i) {
    if (cachedData[i].height <= blockHeight) {
      return cachedData[i].activeKeys;
    }
  }
}

function getCachedData(identityChainId) {
  if (!Array.isArray(this.cache.keys[identityChainId])) {
    this.cache.keys[identityChainId] = [];
  }

  return this.cache.keys[identityChainId];
}

function applyKeyRotations(chainId, initialActiveKeys, initialAllKeys, entries, cachedData) {
  var activeKeys = _toConsumableArray(initialActiveKeys);

  var allKeys = new Set(initialAllKeys);

  for (var i = 0; i < entries.length; ++i) {
    var entry = entries[i];

    if (entry.extIds.length === 5 && entry.extIds[0].toString() === 'ReplaceKey') {
      activeKeys = getUpdatedActiveKeys(chainId, activeKeys, allKeys, entry);
      activeKeys.forEach(function (k) {
        return allKeys.add(k);
      });
      cachedData.push({
        height: entry.blockContext.directoryBlockHeight,
        activeKeys: _toConsumableArray(activeKeys),
        allKeys: _toConsumableArray(allKeys)
      });
    }
  }

  return activeKeys;
}

function getUpdatedActiveKeys(chainId, activeKeys, allKeys, entry) {
  var oldKey = entry.extIds[1].toString(); // 1. Old key must be currently active

  var oldKeyIndex = activeKeys.indexOf(oldKey);

  if (oldKeyIndex === -1) {
    return activeKeys;
  } // 2. New key must have never been active


  var newKey = entry.extIds[2].toString();

  if (allKeys.has(newKey)) {
    return activeKeys;
  } // 3. Signer key must be currently active and of the same or higher priority than the old key


  var signingKey = entry.extIds[4].toString();
  var signingKeyIndex = activeKeys.indexOf(signingKey);

  if (signingKeyIndex === -1 || signingKeyIndex > oldKeyIndex) {
    return activeKeys;
  } // 4. New key must be a valid public identity key


  if (!isValidPublicIdentityKey(newKey)) {
    return activeKeys;
  } // 5. Signature must be correct


  var signedData = Buffer.from(chainId + oldKey + newKey);
  var signature = entry.extIds[3];

  if (signature.length !== 64 || !sign.detached.verify(signedData, signature, extractCryptoMaterial(signingKey))) {
    return activeKeys;
  }

  var newActiveKeys = _toConsumableArray(activeKeys);

  newActiveKeys[oldKeyIndex] = newKey;
  return newActiveKeys;
}

function getInitialKeys(entry) {
  if (entry.extIds[0].toString() !== 'IdentityChain') {
    throw new Error("Invalid first entry ".concat(entry.hash()));
  }

  try {
    // Validate the content is a valid JSON following the format
    var content = JSON.parse(entry.content.toString());
    Joi.assert(content, INITIAL_KEYS_SCHEMA);
    return content.keys;
  } catch (e) {
    throw new Error("Invalid first entry ".concat(entry.hash(), ": ").concat(e.message));
  }
}

function getEntries(_x3, _x4) {
  return _getEntries.apply(this, arguments);
}

function _getEntries() {
  _getEntries = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(cli, identityChainId) {
    var lowerBoundHeight,
        entries,
        _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            lowerBoundHeight = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : -1;
            entries = [];
            _context4.next = 4;
            return cli.rewindChainWhile(identityChainId, function (entry) {
              return entry.blockContext.directoryBlockHeight > lowerBoundHeight;
            }, function (entry) {
              if (basicValidation(entry)) {
                entries.push(entry);
              }
            });

          case 4:
            return _context4.abrupt("return", entries.reverse());

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getEntries.apply(this, arguments);
}

function basicValidation(e) {
  if (e.extIds.length === 0) {
    return false;
  }

  var firstExtId = e.extIds[0].toString();
  return firstExtId === 'ReplaceKey' || firstExtId === 'IdentityChain';
}

function cacheIdentityName(chainId, entry) {
  var identityName = entry.extIds.slice(1).map(function (e) {
    return e.toString('hex');
  });
  this.cache.names[chainId] = identityName;
}

module.exports = {
  IdentityInformationRetriever: IdentityInformationRetriever
};